import { useEffect, useState } from "react";
import { BookOpen, X } from "lucide-react";
import { EBOOK } from "../lib/profile";

/**
 * Floating Ebook CTA — shows on ALL public pages.
 * Positioned bottom-left (to not collide with WhatsApp pill on bottom-right).
 * Can be dismissed via X; state persists in localStorage.
 */
export default function EbookFloating() {
    const [dismissed, setDismissed] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const was = localStorage.getItem("gv_ebook_dismissed") === "1";
        setDismissed(was);
        // Delayed entrance for a little theater
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
    }, []);

    const handleDismiss = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDismissed(true);
        try {
            localStorage.setItem("gv_ebook_dismissed", "1");
        } catch {}
    };

    if (dismissed) return null;

    return (
        <div
            className={`fixed left-3 sm:left-5 bottom-[72px] sm:bottom-6 z-50 transition-all duration-500 pointer-events-none ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
            }`}
            data-testid="ebook-floating-wrap"
        >
            <a
                href={EBOOK.checkoutUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="pointer-events-auto relative group inline-flex items-center gap-3 bg-warm text-navy pl-3 pr-4 py-3 rounded-full shadow-xl hover:bg-warm-600 hover:text-cream transition-all hover:scale-[1.03] active:scale-95 max-w-[88vw] sm:max-w-none"
                data-testid="floating-ebook-btn"
                aria-label="Adquiere el Ebook Arquitecto Digital"
            >
                <span className="relative flex items-center justify-center w-8 h-8 bg-white/30 rounded-full flex-shrink-0">
                    <BookOpen className="w-5 h-5" strokeWidth={1.8} />
                    <span className="absolute inset-0 rounded-full bg-white/40 animate-ping opacity-60" />
                </span>
                <span className="flex flex-col leading-tight text-left min-w-0">
                    <span className="font-semibold tracking-wide text-[13px] whitespace-nowrap">
                        ADQUIERE EL EBOOK
                    </span>
                    <span className="text-[11px] opacity-80 truncate">
                        Conviértete en Arquitecto Digital
                    </span>
                </span>

                <button
                    onClick={handleDismiss}
                    className="ml-1 -mr-1 p-1 rounded-full hover:bg-white/20 transition-colors flex-shrink-0"
                    aria-label="Cerrar"
                    data-testid="ebook-floating-dismiss"
                    type="button"
                >
                    <X className="w-3.5 h-3.5" strokeWidth={2} />
                </button>
            </a>
        </div>
    );
}
